import React, { Fragment } from 'react';
import { Button, Icon } from 'semantic-ui-react'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { Type } from 'react-bootstrap-table2-editor';
import ControlsRenderer from '../../components/controls_component'
import ActionStatusRenderer from '../../components/action_status_renderer'
import { connect } from 'react-redux';
import RiskAction from '../../actions/v2/risk';
import { updateRisk } from '../../actions/risk'
import { saveRiskTranslation } from '../../actions/translations';
import NewEntryModal from '../../components/new_entry_modal'
import DeleteRiskModal from '../../components/delete_risk_modal'
import FiveConsequencesTable from '../consequences_tables/teck/five_consequences_table';
import SixConsequencesTable from '../consequences_tables/teck/six_consequences_table';
import EasyTable from '../../components/easy_table'
import NotificationModal from '../../components/notification_modal'
import AppComponent from '../../components/app_component'
import { UnwantedEventCellFormatter, TranslatableCellFormatter, WorkphaseCellFormatter, ActivityCellFormatter } from './formatters';

import { debounce, getRiskColumnsByLanguage, fiveByFiveLikelihoodOptions, sixBySixLikelihoodOptions, isValidPersonFormat } from '../../helpers';
import { getCurrentLanguage } from '../../helpers/local_storage';
import { initNewWorkPhaseEntry, initNewActivityEntry, initNewHazardEntry, initNewUnwantedEventEntry, formatRiskColumns, updateUnwantedEventColumns, riskRatingFormatter, riskRatingClasses, likelihoodCellFormatter } from '../../helpers/risk_helpers';
import { getText } from '../../helpers';

class PlanTable extends AppComponent {
  constructor(props){
    super(props);

    this.state = {
      newEntry: {},
      showNewEntryForm: false,
      showDeleteForm: false,
      deleteEntry: {},
      language: this.props.language,
      languages: this.props.languages,
      translations: this.props.language.translations,
      languageName: this.props.language.name,
      consequencesShown: false,
      cellRow: {},
      cellColumn: {},
      cellValue: {},
      isNewRisk: false,
      showInvalidRiskOwnerFormatModal: false,
      contextMenu: {
        new: {
          content: 'New',
          style: { float: 'left', cursor: 'pointer' }
        },
        delete: {
          content: 'Delete',
          style: { float: 'left', cursor: 'pointer' }
        },
      },
      rowTranslationStatuses: [],
      outOfScopeDetails: {}
    }

    const { risk_matrix: riskMatrix = '5x5', risk_matrices={} } = props.instanceConfig;
    this.isFiveByFiveMatrix = riskMatrix === '5x5';
    this.isSixBySixMatrix = riskMatrix === '6x6';
    this.sixBySixRiskMatrix = risk_matrices['6x6'] || [];

    this.riskRatingDict = this.props.riskRatingDict
    this.likelihoodOptions = this.props.likelihoodOptions
    this.likelihoodConversionToView = this.props.likelihoodConversionToView

    this.planColumns = this.getColumns()

  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.getTranslationsSuccess){
      this.setState({
        language: nextProps.language,
        languages: nextProps.languages,
        translations: nextProps.language.translations,
        languageName:  nextProps.language.name,
      }, ()=>{
        this.riskRatingDict = nextProps.riskRatingDict
        this.likelihoodOptions = nextProps.likelihoodOptions
        this.likelihoodConversionToView = nextProps.likelihoodConversionToView
        this.planColumns = this.getColumns()
        this.forceUpdate()
      })
    }
  }

  componentWillUpdate = (nextProps, nextState) => {
    if (nextProps.searchFieldsShown){
      this.addFilterFields();
    }
    else {
      this.removeFilterFields();
    }
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    if (nextProps.shouldNotRender){
      return false;
    }
    else {
      return true;
    }
  }

  getColumns = () => {
    const { isFiveByFiveMatrix, isSixBySixMatrix } = this;
    const keyPrefix = isFiveByFiveMatrix ? '' : '6x6_';
    const { translations, languageName } = this.state;
    const { work_phase: work_phase_key, activity: activity_key, hazard: hazard_key, unwanted_event: unwanted_event_key } = getRiskColumnsByLanguage(languageName);
    const riskRatingDeps = { isFiveByFiveMatrix: this.isFiveByFiveMatrix, likelihoodConversionToView: this.likelihoodConversionToView, riskRatingDict: this.riskRatingDict, sixBySixRiskMatrix: this.sixBySixRiskMatrix };
    return [
      {
        dataField: work_phase_key,
        text: translations.work_phase_or_ambient_exposure , //Formerly 'Activity', renamed as requested by the client
        formatter: this.workPhaseCellFormatter,
        editable: (content, row, rowIndex, columnIndex) => (!row.is_custom || !this.props.permission.can_update) ? false: (row.is_custom === "work_phase"),
        editor: {
          type: Type.TEXTAREA
        },
        headerStyle: {
          width: '200px',
          textAlign: "center",
        },
        headerTitle: true,
        title: true,
        editCellClasses: 'textarea-style',
        sort: true,
        align: 'center',
        headerClasses: 'column-color-workphase',
        classes: 'column-color-workphase work-phase-cell',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onContextMenu: (e, cell, rowIndex) => this.onWorkPhaseContextMenu(e, cell, parseInt(rowIndex, 10)),
          onMouseDown: (e) => {
            this.closeContextMenu()
          }
        },
      },
      {
        dataField: activity_key,
        text: translations.activity, //Formerly 'Step in Process', renamed as requested by the client
        formatter: this.activityCellFormatter,
        editable: (content, row, rowIndex, columnIndex) => (!row.is_custom || !this.props.permission.can_update) ? false: (["work_phase", "activity"].includes(row.is_custom)),
        editor: {
          type: Type.TEXTAREA
        },
        headerStyle: {
          width: '180px',
          textAlign: "center",
        },
        headerTitle: true,
        title: true,
        editCellClasses: 'textarea-style',
        sort: true,
        align: 'center',
        headerClasses: 'column-color-activity',
        classes: 'column-color-activity activity-cell',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onContextMenu: (e, cell, rowIndex) => this.onActivityContextMenu(e, cell, parseInt(rowIndex, 10)),
          onMouseDown: (e) => {
            this.closeContextMenu()
          }
        },
      },
      {
        dataField: hazard_key,
        text: translations.hazard,
        formatter: this.cellFormatter,
        editable: (content, row, rowIndex, columnIndex) => (row.is_custom === undefined || !this.props.permission.can_update)? false: (["work_phase", "activity", "hazard"].includes(row.is_custom)),
        editor: {
          type: Type.TEXTAREA
        },
        headerStyle: {
          width: '180px',
          textAlign: "center",
        },
        headerTitle: true,
        title: true,
        editCellClasses: 'textarea-style',
        sort: true,
        align: 'center',
        headerClasses: 'column-color-hazard-event',
        classes: 'column-color-hazard-event hazard-cell',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onContextMenu: (e, cell, rowIndex) => this.onHazardContextMenu(e, cell, parseInt(rowIndex, 10)),
          onMouseDown: (e) => {
            this.closeContextMenu()
          }
        },
      },
      {
        dataField: unwanted_event_key,
        text: translations.unwanted_event,
        formatter: this.unwantedEventCellFormatter,
        editable: (content, row, rowIndex, columnIndex) => (row.is_custom === undefined || !this.props.permission.can_update) ? false: (["work_phase", "activity", "hazard", "unwanted_event"].includes(row.is_custom)),
        editor: {
          type: Type.TEXTAREA
        },
        headerStyle: {
          width: '180px',
          textAlign: "center",
        },
        headerTitle: true,
        title: true,
        editCellClasses: 'textarea-style',
        sort: true,
        align: 'center',
        headerClasses: 'column-color-hazard-event',
        classes: 'column-color-hazard-event unwanted-event-cell',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onContextMenu: (e, cell, rowIndex) => this.onUnwantedEventContextMenu(e, cell, parseInt(rowIndex, 10)),
          onMouseDown: (e) => {
            this.closeContextMenu()
          }
        },
      },
      {
        dataField: 'existing_preventative',
        text: translations.existing_preventative_controls,
        formatter: (cell, row)=>this.controlsCellFormatter(cell, row, this.props.planId, 'existing-preventative'),
        headerTitle: true,
        headerStyle: {
          width: '300px',
          textAlign: "center",
        },
        editable: false,
        hidden: this.props.hiddenControls,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-controls',
        classes: 'column-color-controls',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        cellStyle: {
          width: '300px',
          paddingBottom: '10px'
        }
      },
      {
        dataField: 'existing_recovery',
        text: translations.existing_recovery_controls,
        formatter: (cell, row)=>this.controlsCellFormatter(cell, row, this.props.planId, "existing-recovery"),
        headerStyle: {
          width: '300px',
          textAlign: "center",
        },
        headerTitle: true,
        editCellClasses: 'textarea-style',
        editable: false,
        hidden: this.props.hiddenControls,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-controls',
        classes: 'column-color-controls',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        cellStyle: {
          width: '300px',
          paddingBottom: '10px'
        }
      },
      {
        dataField: `${keyPrefix}likelihood`,
        text: translations.likelihood_of_unwanted_event,
        formatter: (cell, row, rowIndex) => likelihoodCellFormatter(cell, row, rowIndex, this.likelihoodOptions),
        editor: {
          type: 'dropdown',
          options: this.likelihoodOptions
        },
        headerStyle: {
          width: '220px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-likelihood-consequence',
        classes: 'column-color-likelihood-consequence',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        editable: this.props.permission.can_update
      },
      {
        dataField: 'consequences_description',
        text: translations.consequence_text_description,
        formatter: this.translatableCellFormatter,
        editCellClasses: 'textarea-style',
        editor: {
          type: Type.TEXTAREA
        },
        headerStyle: {
          width: '300px',
          textAlign: "center",
        },
        cellInnerDivStyle: {
          height: "100%"
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-likelihood-consequence',
        classes: 'column-color-likelihood-consequence description',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        editable: this.isEditableCell
      },
      {
        dataField: `${keyPrefix}financial`,
        text: translations.financial,
        headerStyle: {
          width: '100px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-ratings',
        classes: 'column-color-ratings',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onClick: (evt, cell, row, column, rowIndex, colIndex) => this.renderConsequencesTable(cell, row, column, rowIndex, colIndex),
        },
        editor: {
          type: 'modal'
        },
        editable: this.props.permission.can_update
      },
      {
        dataField: `${keyPrefix}safety`,
        text: translations.safety, //Safety
        headerStyle: {
          width: '100px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-ratings',
        classes: 'column-color-ratings',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onClick: (evt, cell, row, column, rowIndex, colIndex) => this.renderConsequencesTable(cell, row, column, rowIndex, colIndex),
        },
        editor: {
          type: 'modal'
        },
        editable: this.props.permission.can_update
      },
      {
        dataField: `${keyPrefix}health`,
        text: translations.occ_health, //Health
        headerStyle: {
          width: '100px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-ratings',
        classes: 'column-color-ratings',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onClick: (evt, cell, row, column, rowIndex, colIndex) => this.renderConsequencesTable(cell, row, column, rowIndex, colIndex),
        },
        editor: {
          type: 'modal'
        },
        editable: this.props.permission.can_update,
        hidden: isSixBySixMatrix
      },
      {
        dataField: `${keyPrefix}hygiene`,
        text: getText("Hygiene"),
        headerStyle: {
          width: '100px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-ratings',
        classes: 'column-color-ratings',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onClick: (evt, cell, row, column, rowIndex, colIndex) => this.renderConsequencesTable(cell, row, column, rowIndex, colIndex),
        },
        editor: {
          type: 'modal'
        },
        editable: this.props.permission.can_update,
        hidden: isFiveByFiveMatrix
      },
      {
        dataField: `${keyPrefix}reputation`,
        text: translations.reputation,
        headerStyle: {
          width: '100px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-ratings',
        classes: 'column-color-ratings',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onClick: (evt, cell, row, column, rowIndex, colIndex) => this.renderConsequencesTable(cell, row, column, rowIndex, colIndex),
        },
        editor: {
          type: 'modal'
        },
        editable: this.props.permission.can_update
      },
      {
        dataField: `${keyPrefix}environmental`,
        text: translations.environment, //'Environment'
        headerStyle: {
          width: '100px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-ratings',
        classes: 'column-color-ratings',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onClick: (evt, cell, row, column, rowIndex, colIndex) => this.renderConsequencesTable(cell, row, column, rowIndex, colIndex),
        },
        editor: {
          type: 'modal'
        },
        editable: this.props.permission.can_update
      },
      {
        dataField: `${keyPrefix}legal`,
        text: translations.legal, //'Legal'
        headerStyle: {
          width: '100px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-ratings',
        classes: 'column-color-ratings',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onClick: (evt, cell, row, column, rowIndex, colIndex) => this.renderConsequencesTable(cell, row, column, rowIndex, colIndex),
        },
        editor: {
          type: 'modal'
        },
        editable: this.props.permission.can_update
      },
      {
        dataField: `${keyPrefix}community`,
        text: translations.community,
        headerStyle: {
          width: '100px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-ratings',
        classes: 'column-color-ratings',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onClick: (evt, cell, row, column, rowIndex, colIndex) => this.renderConsequencesTable(cell, row, column, rowIndex, colIndex),
        },
        editor: {
          type: 'modal'
        },
        editable: this.props.permission.can_update
      },
      {
        dataField: 'current_risk_rating',
        text: translations.current_risk_rating,
        formatter: (cell, row) => riskRatingFormatter(cell, row, riskRatingDeps),
        headerStyle: {
          width: '120px',
          textAlign: "center",
        },
        title: false,
        editable: false,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-risk-rating',
        classes: (cell, row) => riskRatingClasses(cell, row, riskRatingDeps),
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
      {
        dataField: 'additional_preventative',
        text: translations.additional_preventative_controls,
        formatter: (cell, row)=>this.controlsCellFormatter(cell, row, this.props.planId, "additional-preventative"),
        headerStyle: {
          width: '300px',
          textAlign: "center",
        },
        headerTitle: true,
        editable: false,
        hidden: this.props.hiddenControls,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-controls',
        classes: 'column-color-controls',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        cellStyle: {
          width: '300px',
          paddingBottom: '10px'
        }
      },
      {
        dataField: 'additional_recovery',
        text: translations.additional_recovery_controls,
        formatter: (cell, row)=>this.controlsCellFormatter(cell, row, this.props.planId, "additional-recovery"),
        headerStyle: {
          width: '300px',
          textAlign: "center",
        },
        headerTitle: true,
        editCellClasses: 'textarea-style',
        editable: false,
        hidden: this.props.hiddenControls,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-controls',
        classes: 'column-color-controls',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        cellStyle: {
          width: '300px',
          paddingBottom: '10px'
        }
      },
      {
        dataField: `${keyPrefix}new_likelihood`,
        text: translations.likelihood_of_unwanted_event,
        formatter: (cell, row, rowIndex) => likelihoodCellFormatter(cell, row, rowIndex, this.likelihoodOptions),
        editor: {
          type: 'dropdown',
          options: this.likelihoodOptions
        },
        headerStyle: {
          width: '220px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-likelihood-consequence',
        classes: 'column-color-likelihood-consequence',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        editable: this.props.permission.can_update,
        hidden: false,
      },
      {
        dataField: `${keyPrefix}new_financial`,
        text: translations.financial,
        headerStyle: {
          width: '100px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-ratings',
        classes: 'column-color-ratings',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onClick: (evt, cell, row, column, rowIndex, colIndex) => this.renderConsequencesTable(cell, row, column, rowIndex, colIndex),
        },
        editor: {
          type: 'modal'
        },
        editable: this.props.permission.can_update,
        hidden: false,
      },
      {
        dataField: `${keyPrefix}new_safety`,
        text: translations.safety, //Safety
        headerStyle: {
          width: '100px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-ratings',
        classes: 'column-color-ratings',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onClick: (evt, cell, row, column, rowIndex, colIndex) => this.renderConsequencesTable(cell, row, column, rowIndex, colIndex),
        },
        editor: {
          type: 'modal'
        },
        editable: this.props.permission.can_update,
        hidden: false,
      },
      {
        dataField: `${keyPrefix}new_health`,
        text: translations.occ_health, //Health
        headerStyle: {
          width: '100px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-ratings',
        classes: 'column-color-ratings',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onClick: (evt, cell, row, column, rowIndex, colIndex) => this.renderConsequencesTable(cell, row, column, rowIndex, colIndex),
        },
        editor: {
          type: 'modal'
        },
        editable: this.props.permission.can_update,
        hidden: isSixBySixMatrix
      },
      {
        dataField: `${keyPrefix}new_hygiene`,
        text: getText("Hygiene"),
        headerStyle: {
          width: '100px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-ratings',
        classes: 'column-color-ratings',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onClick: (evt, cell, row, column, rowIndex, colIndex) => this.renderConsequencesTable(cell, row, column, rowIndex, colIndex),
        },
        editor: {
          type: 'modal'
        },
        editable: this.props.permission.can_update,
        hidden: isFiveByFiveMatrix
      },
      {
        dataField: `${keyPrefix}new_reputation`,
        text: translations.reputation,
        headerStyle: {
          width: '100px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-ratings',
        classes: 'column-color-ratings',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onClick: (evt, cell, row, column, rowIndex, colIndex) => this.renderConsequencesTable(cell, row, column, rowIndex, colIndex),
        },
        editor: {
          type: 'modal'
        },
        editable: this.props.permission.can_update,
        hidden: false,
      },
      {
        dataField: `${keyPrefix}new_environmental`,
        text: translations.environment, //'Environment'
        headerStyle: {
          width: '100px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-ratings',
        classes: 'column-color-ratings',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onClick: (evt, cell, row, column, rowIndex, colIndex) => this.renderConsequencesTable(cell, row, column, rowIndex, colIndex),
        },
        editor: {
          type: 'modal'
        },
        editable: this.props.permission.can_update,
        hidden: false,
      },
      {
        dataField: `${keyPrefix}new_legal`,
        text: translations.legal, //'Legal'
        headerStyle: {
          width: '100px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-ratings',
        classes: 'column-color-ratings',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onClick: (evt, cell, row, column, rowIndex, colIndex) => this.renderConsequencesTable(cell, row, column, rowIndex, colIndex),
        },
        editor: {
          type: 'modal'
        },
        editable: this.props.permission.can_update,
        hidden: false,
      },
      {
        dataField: `${keyPrefix}new_community`,
        text: translations.community,
        headerStyle: {
          width: '100px',
          textAlign: "center",
        },
        title: true,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-ratings',
        classes: 'column-color-ratings',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        events: {
          onClick: (evt, cell, row, column, rowIndex, colIndex) => this.renderConsequencesTable(cell, row, column, rowIndex, colIndex),
        },
        editor: {
          type: 'modal'
        },
        editable: this.props.permission.can_update,
        hidden: false,
      },
      {
        dataField: 'final_risk_rating',
        text: translations.final_risk_rating,
        formatter: (cell, row) => riskRatingFormatter(cell, row, { ...riskRatingDeps, isFinal: true }),
        headerStyle: {
          width: '120px',
          textAlign: "center",
        },
        title: false,
        editable: false,
        sort: true,
        align: 'center',
        headerClasses: 'column-color-risk-rating',
        classes: (cell, row) => riskRatingClasses(cell, row, { ...riskRatingDeps, isFinal: true }),
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
      {
        dataField: 'actions',
        text: translations.numbered_1,
        formatter: this.translatableCellFormatter,
        editor: {
          type: Type.TEXTAREA
        },
        headerStyle: {
          width: '300px',
        },
        cellInnerDivStyle: {
          height: "100%"
        },
        headerTitle: true,
        title: true,
        editCellClasses: 'textarea-style',
        sort: true,
        headerClasses: 'column-color-actions',
        classes: 'column-color-actions',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        editable: this.isEditableCell
      },
      {
        dataField: 'manager',
        text: translations.numbered_2,
        formatter: this.riskOwnerFormatter,
        editor: {
          type: Type.TEXTAREA,
          placeholder: `Enter name and email address. ${translations.accountable_people_format}: Firstname Lastname (email) - eg. John Doe (john.doe@teck.com)`
        },
        headerStyle: {
          width: '300px',
        },
        headerTitle: true,
        title: true,
        editCellClasses: 'textarea-style',
        sort: true,
        headerClasses: 'column-color-actions',
        classes: 'column-color-actions',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy, `${translations.format} - eg. John Doe (john.doe@teck.com)`),
        editable: this.props.permission.can_update,
        validator: this.validateRiskOwnerFormat
      },
      {
        dataField: 'effectiveness',
        text: translations.numbered_3,
        formatter: this.translatableCellFormatter,
        editor: {
          type: Type.TEXTAREA
        },
        headerStyle: {
          width: '300px',
        },
        cellInnerDivStyle: {
          height: "100%"
        },
        headerTitle: true,
        title: true,
        editCellClasses: 'textarea-style',
        sort: true,
        headerClasses: 'column-color-actions',
        classes: 'column-color-actions',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        editable: this.isEditableCell
      },
      {
        dataField: 'status',
        text: translations.numbered_4,
        formatter: (cell, row) => this.actionStatusRenderer(cell, row),
        headerStyle: {
          width: '300px',
        },
        headerTitle: true,
        sort: true,
        editable: false,
        headerClasses: 'column-color-actions',
        classes: 'column-color-actions',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
      },
      {
        dataField: 'effectiveness2',
        text: translations.numbered_5,
        formatter: this.translatableCellFormatter,
        editor: {
          type: Type.TEXTAREA
        },
        headerStyle: {
          width: '300px',
        },
        cellInnerDivStyle: {
          height: "100%"
        },
        headerTitle: true,
        title: true,
        editCellClasses: 'textarea-style',
        sort: true,
        headerClasses: 'column-color-actions',
        classes: 'column-color-actions',
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy),
        editable: this.isEditableCell
      },
    ];
  }

  riskOwnerFormatter = (cell, row, rowIndex) => {
    var cell_is_empty = ((cell && cell.length == 0) || !cell);
    return (
     <span className={ cell_is_empty ? 'risk-owner-cell cell-style text-muted' : 'risk-owner-cell cell-style' } row={ rowIndex }>
      { !cell_is_empty && cell }
     </span>
    );
  }

  cellFormatter = (cell, row, rowIndex) => {
    const { languageName } = this.state;
    const { work_phase: work_phase_key, activity: activity_key, hazard: hazard_key, unwanted_event: unwanted_event_key } = getRiskColumnsByLanguage(languageName);
    var color = ""
    if(row[work_phase_key] === cell && row.is_custom === "work_phase") {
      color = "editable-cell"
    }
    else if(row[activity_key] === cell && ["work_phase", "activity"].includes(row.is_custom)) {
      color = "editable-cell"
    }
    else if(row[hazard_key] === cell && ["work_phase", "activity", "hazard"].includes(row.is_custom)) {
      color = "editable-cell"
    }
    else if(row[unwanted_event_key] === cell && ["work_phase", "activity", "hazard", "unwanted_event"].includes(row.is_custom)) {
      color = "editable-cell"
    }

    if(cell !== null && cell === row.likelihood){
      if(row.likelihood === '(N/A) Not Applicable') {
        cell = this.likelihoodConversionToView['N/A']
      } else {
        cell = this.likelihoodConversionToView[row.likelihood.split(' – ')[0]]
      }
    }
    if(cell !== null && cell === row.new_likelihood){
      if(row.new_likelihood === '(N/A) Not Applicable') {
        cell = this.likelihoodConversionToView['N/A']
      } else {
        cell = this.likelihoodConversionToView[row.new_likelihood.split(' – ')[0]]
      }
    }

    return (
     <span className={ 'cell-style ' + color } cell={ cell } row={ rowIndex }>
      { cell }
     </span>
    );
  }

  workPhaseCellFormatter = (cell, row, rowIndex) => {
    const { features } = this.props.instanceConfig
    const isBusinessAreaTagsEnabled = features && features.business_area_tags;

    return (
      <WorkphaseCellFormatter
        cell={this.cellFormatter(cell, row, rowIndex)}
        row={row}
        translations={this.state.translations}
        canUpdate={this.props.permission && this.props.permission.can_update}
        isBusinessAreaTagsEnabled={isBusinessAreaTagsEnabled}
      />
    );
  }

  translatableCellFormatter = (cell, row, rowIndex, column) => {
    const { features } = this.props.instanceConfig
    const isEnabledTranslations = features && features.ai_translation

    if(!isEnabledTranslations) {
      return this.cellFormatter(cell, row, rowIndex)
    }
  
    return (
      <TranslatableCellFormatter
        cell={cell}
        row={row}
        column={column}
        rowIndex={rowIndex}
        getRowTranslation={this.getRowTranslation}
        saveRiskTranslation={this.props.saveRiskTranslation}
        rowTranslationStatuses={this.state.rowTranslationStatuses}
        onTranslationRequested={this.onTranslationRequested}
        onTranslationSuccess={this.onTranslationSuccess}
        onTranslationFailed={this.onTranslationFailed}
        showRiskCellTranslation={this.props.showRiskCellTranslation}
        hideRiskCellTranslation={this.props.hideRiskCellTranslation}
      />
    );
  }

  unwantedEventCellFormatter = (cell, row, rowIndex) => {
    const { permission, instanceConfig, TagOptions, refreshUpdatedRisk, riskRatingDict, likelihoodConversionToView } = this.props;
    const { features } = instanceConfig
    const isRisksComparisonEnabled = features && features.risks_comparison
    const isUnwantedEventsComparisonEnabled = features && features.unwanted_events_comparison

    return (
      <UnwantedEventCellFormatter
        cell={cell}
        row={row}
        permission={permission}
        isRisksComparisonEnabled={isRisksComparisonEnabled}
        isUnwantedEventsComparisonEnabled={isUnwantedEventsComparisonEnabled}
        TagOptions={TagOptions}
        refreshUpdatedRisk={refreshUpdatedRisk}
        riskRatingDict={riskRatingDict}
        likelihoodConversionToView={likelihoodConversionToView}
      />
    );
  }

  activityCellFormatter = (cell, row, _) => {
    const { iauditor_inspections=false } = this.props.instanceConfig;
    return (
      <ActivityCellFormatter
        cell={cell}
        row={row}
        canCreateInspection={iauditor_inspections}
        onCreateInspectionSuccess={this.props.onCreateInspectionSuccess}
      />
    )
  }

  controlsCellFormatter = (cell, row, planId, controlType) => {
    const currentInspection = row.inspections && row.inspections.length > 0 && row.inspections[0];

    return <ControlsRenderer
            className="register-controls-list"
            value={cell}
            planId={planId}
            riskId={row.id}
            controlType={controlType}
            setTagOptions={this.setTagOptions.bind(this)}
            translations={this.state.translations}
            TagOptions={this.props.TagOptions}
            permission={this.props.permission}
            currentInspection={currentInspection}
          />
  }

  actionStatusRenderer = (cell, row) => {
    return (
      <ActionStatusRenderer
        details= { cell }
        changeHanler={ (details) => this.updateRisk(null, details, row, {dataField:'status'}, null) }
        translations={this.state.translations}
        permission={this.props.permission}
      />
    )
  }

  headerFormatter = (column, filterElement, sortBy, description=null) => {
    var text;
    text = column.text
    return (
      <div style={ { display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between' } }>
        { text }
        { description && <div class="text-muted">{description}</div> }
        { sortBy != null && sortBy.field === column.dataField && this.sortIcon(sortBy.order) }
        { filterElement }
      </div>
    );
  }

  riskRatingClass = (cell, row, rowIndex, colIndex, isFinal) => {
    var risk_rating = parseInt(cell, 10)
    if(risk_rating === 0 || !risk_rating ) {
      return 'column-color-risk-rating'
    }

    var risk_rating_props = this.getRiskRatingProps(cell, row, isFinal);
    return risk_rating_props ? risk_rating_props.class + ' column-color-risk-rating' : 'column-color-risk-rating'
  }

  getRiskRatingProps = (cell, row, isFinal) => {
    var risk_rating_props = {};
    var risk_rating = parseInt(cell, 10);
    var row_likelihood = isFinal ? row.new_likelihood : row.likelihood;
    if(row_likelihood === '(N/A) Not Applicable') {
      return this.riskRatingDict['N/A'][0];
    }

    if (risk_rating && risk_rating > 0 && row_likelihood) {
      const likelihood_rating = row_likelihood.split(' – ')[0];
      return this.riskRatingDict[likelihood_rating.toString()][risk_rating];
    }
    return risk_rating_props;
  }

  sortIcon = (order) => {
     if(order.toUpperCase() === 'ASC') {
       return <div className='sort-icon-div'><Icon name='angle up'/>ASC</div>
     }
     else {
       return <div className='sort-icon-div'><Icon name='angle down'/>DESC</div>
     }
  }

  toggleControls = (hide) => {
    this.planColumns[5].hidden = hide;
    this.planColumns[6].hidden = hide;
    this.planColumns[17].hidden = hide;
    this.planColumns[18].hidden = hide;
  }

  renderConsequencesTable = (cell, row, column, rowIndex, colIndex) => {
    this.setState({
      cellValue: cell,
      cellRow: row,
      cellColumn: column,
      isNewRisk: (column.dataField.includes('new_') ? true : false),
      consequencesShown: true
    })
  }

  onConsequencesUpdate = (newValue) => {
    this.setState({
      cellValue: newValue,
      consequencesShown: false
    })
  }

  
  validateRiskOwnerFormat = (riskOwner) => {
    const cleanOwner = riskOwner.replaceAll("\n", "").trim();
    if(!cleanOwner) return true;

    const isValidUser = isValidPersonFormat(cleanOwner)

    if (!isValidUser){
      this.setState({ showInvalidRiskOwnerFormatModal: true })
    }
    return isValidUser
  }

  closeInvalidRiskOwnerFormatModal = (evt) => {
    this.setState({showInvalidRiskOwnerFormatModal: false})
  }

  updateRisk = (oldValue, newValue, row, column, object) => {
    if (oldValue === newValue) {
      return;
    }

    if (['work_phase_or_ambient_exposure', 'work_phase_spanish', 'work_phase_turkish', 'activity', 'activity_spanish', 'activity_turkish', 'hazard', 'hazard_spanish', 'hazard_turkish'].includes(column.dataField)) {
      this.props.onUpdateRisks(newValue, oldValue, column.dataField, row)
      return
    }

    if(column.dataField === 'manager') {
      if (!this.validateRiskOwnerFormat(newValue)) {
        return
      }
      this.props.updateAccountableManager({ manager: newValue, id: row.id, plan_id: this.props.planId })
    }

    let { id, metadata } = row;
    const { dataField } = column;

    if (dataField.includes("unwanted_event")) {
      updateUnwantedEventColumns(newValue, metadata);
    } else if (['likelihood', 'new_likelihood'].includes(dataField)) {
      this.updateFiveByFiveLikelihood(metadata, newValue, dataField);
    } else if (['6x6_likelihood', '6x6_new_likelihood'].includes(dataField)) {
      this.updateSixBySixLikelihood(metadata, newValue, dataField);
    } else if (['financial', 'safety', 'health', 'environmental', 'reputation', 'legal', 'community'].includes(dataField)) {
      this.updateFiveByFiveConsequence(metadata, newValue, dataField);
    } else if (['new_financial', 'new_safety', 'new_health', 'new_environmental', 'new_reputation', 'new_legal', 'new_community'].includes(dataField)) {
      this.updateFiveByFiveConsequence(metadata, newValue, dataField);
    } else if (['6x6_financial', '6x6_safety', '6x6_hygiene', '6x6_environmental', '6x6_reputation', '6x6_legal', '6x6_community'].includes(dataField)) {
      this.updateSixBySixConsequence(metadata, newValue, dataField);
    } else if (['6x6_new_financial', '6x6_new_safety', '6x6_new_hygiene', '6x6_new_environmental', '6x6_new_reputation', '6x6_new_legal', '6x6_new_community'].includes(dataField)) {
      this.updateSixBySixConsequence(metadata, newValue, dataField);
    } else {
      metadata[dataField] = newValue
    }

    metadata = formatRiskColumns(metadata, row);

    const risk = {
      id,
      metadata: JSON.stringify(metadata)
    };
    this.props.updateRisk(this.props.planId, risk, newValue, row);
  }

  updateFiveByFiveLikelihood = (metadata, newValue, dataField) => {
    const likelihood = this.getLikelihoodValues(newValue, fiveByFiveLikelihoodOptions());
    metadata[dataField] = likelihood;

    const new_likelihood = metadata['new_likelihood'] || { type: '', value: '' };
    if (dataField === 'likelihood' && newValue && !new_likelihood.value) {
      metadata['new_likelihood'] = likelihood;
    }
  }

  updateSixBySixLikelihood = (metadata, newValue, dataField) => {
    const likelihood = this.getLikelihoodValues(newValue, sixBySixLikelihoodOptions());
    metadata[dataField] = likelihood;

    const new_likelihood = metadata['6x6_new_likelihood'] || { type: '', value: '' };
    if (dataField === '6x6_likelihood' && newValue && !new_likelihood.value) {
      metadata['6x6_new_likelihood'] = likelihood;
    }
  }

  getLikelihoodValues = (likelihoodValue, likelihoodOptions) => {
    const matchedLikelihood = likelihoodOptions.find(likelihood => likelihood.value === likelihoodValue)
    if (!matchedLikelihood) return { type: '', value: '' };

    const { type, value } = matchedLikelihood;
    return { type, value };
  }

  updateFiveByFiveConsequence = (metadata, newValue, consequenceKey) => {
    const isAdditionalConsequence = consequenceKey.includes('new');
    const consequencesKey = isAdditionalConsequence ? 'new_consequences' : 'consequences';
    const consequences = this.getOrSetConsequences(metadata, consequencesKey);
    this.updateOrAddConsequence(newValue, consequences, consequenceKey)

    if (!isAdditionalConsequence) {
      const newConsequences = this.getOrSetConsequences(metadata, 'new_consequences');
      const newConsequenceKey = `new_${consequenceKey}`;
      this.updateOrAddConsequence(newValue, newConsequences, newConsequenceKey, true)
    }

  }

  updateSixBySixConsequence = (metadata, newValue, consequenceKey) => {
    const isAdditionalConsequence = consequenceKey.includes('new');
    const consequencesKey = isAdditionalConsequence ? '6x6_new_consequences' : '6x6_consequences';
    const consequences = this.getOrSetConsequences(metadata, consequencesKey);
    this.updateOrAddConsequence(newValue, consequences, consequenceKey)

    if (!isAdditionalConsequence) {
      const newConsequences = this.getOrSetConsequences(metadata, '6x6_new_consequences');
      const newConsequenceKey = consequenceKey.replace('6x6', '6x6_new');
      this.updateOrAddConsequence(newValue, newConsequences, newConsequenceKey, true)
    }

  }

  getOrSetConsequences = (metadata, consequencesKey) => {
    if (!Object.keys(metadata).includes(consequencesKey)) {
      metadata[consequencesKey] = [];
    }
    return metadata[consequencesKey];
  }

  updateOrAddConsequence = (newValue, consequences, consequenceKey, onlyIfBlank=false) => {
    const matchedConsequence = consequences.find(consequence => consequence.key === consequenceKey);
    
    if (!matchedConsequence) {
      consequences.push({ key: consequenceKey, value: newValue });
    } else if (!onlyIfBlank || (onlyIfBlank && !matchedConsequence.value)) {
      matchedConsequence.value = newValue
    }
  }

  addFilterFields = () => {
    const uRLSearchParams = this.props.uRLSearchParams
    const columnName = uRLSearchParams.get("column_name");
    const searchTerm = uRLSearchParams.get("search_term");

    this.planColumns.forEach((column) => {
      const defaultValue = column.dataField.includes(columnName) && searchTerm ? searchTerm : '';
      column.filter = { defaultValue };
    })
  }

  removeFilterFields = () => {
    this.planColumns.forEach((column) => {
      delete column.filter;
    })
  }

  setTagOptions = (tag) => {
    this.props.setTagOptions(tag);
  }

  onSubmitEntry = (risk) => {
    this.props.createRisk(risk)
    this.toggleNewEntryForm(false)
  }

  onDelete = (details) => {
    this.props.deleteRisks(details)

    this.setState({
      showDeleteForm: false
    })
  }

  onTranslationRequested = (rowId) => {
    const rowTranslationStatuses = [...this.state.rowTranslationStatuses]
    const translationStatus = rowTranslationStatuses.find(item => item.rowId === rowId)
    if(translationStatus) {
      translationStatus.status = "loading"
    } else {
      rowTranslationStatuses.push({ rowId, status: "loading" })
    }
    this.setState({ rowTranslationStatuses })
  }

  onTranslationSuccess = (row, translation) => {
    const rowTranslationStatuses = [...this.state.rowTranslationStatuses]
    this.setState({ rowTranslationStatuses: rowTranslationStatuses.filter(item => item.rowId !== row.id) })
    this.props.saveRiskTranslation(row, translation)
  }

  onTranslationFailed = (rowId) => {
    const rowTranslationStatuses = [...this.state.rowTranslationStatuses]
    const translationStatus = rowTranslationStatuses.find(item => item.rowId === rowId)
    translationStatus.status = "failed"
    this.setState({ rowTranslationStatuses })
  }

  tableHeader = (hiddenRisksShown, showHiddenRisks) => {
    if(!hiddenRisksShown) {
      return ''
    }

    const { translations } = this.state

    var headerText = translations.select_activities
    var buttonText = translations.goto_project

    return (
      <div>
        <div className="plan-title ui header">{headerText}</div>
        <div className="toggle-button-div">
          <Button color='blue' fluid size='medium' onClick={() => showHiddenRisks(!hiddenRisksShown)} className="toggle-activities-button"><i className="eye slash alternate icon"></i>{buttonText}</Button>
        </div>
      </div>
    )
  }

  onTableChange = (type, newState) => {
    if(type === 'sort') {
      var sortBy = {
        field: newState.sortField,
        order: newState.sortOrder
      }
      this.props.setSortBy(sortBy)
    }
    else if(type === 'filter') {
      var columnName = Object.getOwnPropertyNames(newState.filters)[0];
      this.props.setColumnName(columnName);
      if (newState.filters[columnName]){
        var searchTerm = newState.filters[columnName]['filterVal'];
        this.props.setSearchTerm(searchTerm);
      }
      else {
        this.props.setSearchTerm('');
      }
    }
    this.debouncedLoadPlan();
  }

  debouncedLoadPlan = () => {
    this.planTimer = debounce(this.props.loadPlan, 1000, this.planTimer)()
  }

  onWorkPhaseContextMenu = (event, cell, rowIndex) => {
    const { risks, permission, instanceConfig } = this.props;
    const { enable_workphase_addition: workphaseAdditionEnabled } = instanceConfig;

    if (!permission.can_update || !workphaseAdditionEnabled) return;

    event.preventDefault();
    this.closeContextMenu()

    const { languageName } = this.state;
    const selectedRisk = {...risks[rowIndex]};
    const isCustomWorkPhase = selectedRisk.is_custom === "work_phase";

    let deleteEntry = {};
    const riskDetails = {...selectedRisk, is_custom: "work_phase", hidden: false };
    const newEntry = initNewWorkPhaseEntry(riskDetails);

    let contextMenu = {
      new: {
        content: `${getText('New')} ${getText('Work Phase or Ambient Exposure')}`,
        style: { float: 'left', cursor: 'pointer' }
      }
    }

    if (isCustomWorkPhase) {
      contextMenu.delete = {
        content: getText('Delete'),
        style: { float: 'left', cursor: 'pointer' }
      }

      deleteEntry = {...selectedRisk, column: 'work_phase', languageName: languageName }
    }

    this.setState({ newEntry, contextMenu, deleteEntry })

    const menuElement = document.getElementById("plan_table_contextmenu");
    this.autoPositionElement(event, menuElement)
  }

  onActivityContextMenu = (event, cell, rowIndex) => {
    if (!this.props.permission.can_update) return;
    
    event.preventDefault();
    this.closeContextMenu()

    const { languageName } = this.state;
    const { risks } = this.props;
    const selectedRisk = {...risks[rowIndex]};
    const isCustomActivity = ['work_phase', 'activity'].includes(selectedRisk.is_custom);
    const hasCustomLevels = selectedRisk.is_custom === "work_phase";
    const isCustom = hasCustomLevels ? selectedRisk.is_custom : "activity";

    let deleteEntry = {};
    const riskDetails = {...selectedRisk, is_custom: isCustom, hidden: false };
    const newEntry = initNewActivityEntry(riskDetails);

    let contextMenu = {
      new: {
        content: `${getText('New')} ${getText('Activity')}`,
        style: { float: 'left', cursor: 'pointer' }
      }
    }

    if (isCustomActivity) {
      contextMenu.delete = {
        content: getText('Delete'),
        style: { float: 'left', cursor: 'pointer' }
      }

      deleteEntry = {...selectedRisk, column: 'activity', languageName: languageName }
    }

    this.setState({ newEntry, contextMenu, deleteEntry })

    const menuElement = document.getElementById("plan_table_contextmenu");
    this.autoPositionElement(event, menuElement)
  }

  onHazardContextMenu = (event, cell, rowIndex) => {
    if (!this.props.permission.can_update) return;
    
    event.preventDefault();
    this.closeContextMenu()

    const { languageName } = this.state;
    const { risks } = this.props;
    const selectedRisk = {...risks[rowIndex]};
    const isCustomHazard = ['work_phase', 'activity', 'hazard'].includes(selectedRisk.is_custom);
    const hasCustomLevels = ['work_phase', 'activity'].includes(selectedRisk.is_custom);
    const isCustom = hasCustomLevels ? selectedRisk.is_custom : "hazard";

    let deleteEntry = {};
    const riskDetails = {...selectedRisk, is_custom: isCustom, hidden: false };
    const newEntry = initNewHazardEntry(riskDetails);

    let contextMenu = {
      new: {
        content: `${getText('New')} ${getText('Hazard (Risk Source)')}`,
        style: { float: 'left', cursor: 'pointer' }
      }
    }

    if (isCustomHazard) {
      contextMenu.delete = {
        content: getText('Delete'),
        style: { float: 'left', cursor: 'pointer' }
      }

      deleteEntry = {...selectedRisk, column: 'hazard', languageName: languageName }
    }

    this.setState({ newEntry, contextMenu, deleteEntry })

    const menuElement = document.getElementById("plan_table_contextmenu");
    this.autoPositionElement(event, menuElement)
  }

  onUnwantedEventContextMenu = (event, cell, rowIndex) => {
    if (!this.props.permission.can_update) return;
    
    event.preventDefault();
    this.closeContextMenu()

    const { languageName } = this.state;
    const { risks } = this.props;
    const selectedRisk = {...risks[rowIndex]};
    const isCustomEvent = ['work_phase', 'activity', 'hazard', 'unwanted_event'].includes(selectedRisk.is_custom);
    const hasCustomLevels = ['work_phase', 'activity', 'hazard'].includes(selectedRisk.is_custom);
    const isCustom = hasCustomLevels ? selectedRisk.is_custom : "unwanted_event";

    let deleteEntry = {};
    let { plan_id, work_phase_or_ambient_exposure, activity, hazard, unwanted_event } = selectedRisk;
    work_phase_or_ambient_exposure = work_phase_or_ambient_exposure ? work_phase_or_ambient_exposure.trim() : '';
    activity = activity ? activity.trim() : '';
    hazard = hazard ? hazard.trim() : '';
    unwanted_event = unwanted_event ? unwanted_event.trim() : '';

    const outOfScopeDetails = {
      plan_id,
      column_name: 'unwanted_event',
      hidden: true,
      search_term: `${work_phase_or_ambient_exposure} / ${activity} / ${hazard} / ${unwanted_event}`
    }

    const riskDetails = {...selectedRisk, is_custom: isCustom, hidden: false };
    const newEntry = initNewUnwantedEventEntry(riskDetails);

    let contextMenu = {
      out_of_scope: {
        content: getText('Mark as Out of Scope'),
        style: { float: 'left', cursor: 'pointer' }
      },
      new: {
        content: `${getText('New')} ${getText('(Unwanted) Event')}`,
        style: { float: 'left', cursor: 'pointer' }
      }
    }

    if (isCustomEvent) {
      contextMenu.delete = {
        content: getText('Delete'),
        style: { float: 'left', cursor: 'pointer' }
      }

      deleteEntry = {...selectedRisk, column: 'unwanted_event', languageName: languageName }
    }

    this.setState({ newEntry, contextMenu, deleteEntry, outOfScopeDetails })

    const menuElement = document.getElementById("plan_table_contextmenu");
    this.autoPositionElement(event, menuElement)
  }

  closeContextMenu = () => {
    let menu = document.getElementById("plan_table_contextmenu");
    menu.style.cssText = 'visibility: hidden;';
  }

  isEditableCell = (cell, row, rowIndex, colIndex, column) => {
    const { features } = this.props.instanceConfig
    const isEnabledTranslations = features && features.ai_translation

    if(!isEnabledTranslations) {
      return this.props.permission.can_update;
    }

    return this.props.permission.can_update;
  }

  getRowTranslation = (rowId) => {
    const { risksTranslations } = this.props.translations || {};
    const language = getCurrentLanguage();
    const translation = risksTranslations && risksTranslations[rowId];
    return translation && translation[language];
  }

  toggleRisksByLevel = () => {
    this.closeContextMenu();

    const { outOfScopeDetails } = this.state;
    this.props.toggleRisksByLevel(outOfScopeDetails);
  }

  render() {
    const { risks } = this.props;
    const { translations, showInvalidRiskOwnerFormatModal, showNewEntryForm, contextMenu, newEntry, showDeleteForm, deleteEntry } = this.state;
    const { isFiveByFiveMatrix } = this;

    return (
      <span>
        {
          <EasyTable
            keyField='id'
            columns={this.planColumns}
            data={risks}
            lockedColumnHeadings={true}
            showHeading={false}
            loader={this.props.loader}
            fetchMore={this.props.fetchMoreRisk}
            defaultSort={{ sortField: 'work_phase_or_ambient_exposure', sortOrder: 'asc'}}
            columnEvent={ this.onTableChange }
            cellEvent={(oldValue, newValue, row, column) => this.updateRisk(oldValue, newValue, row, column, null)}
            translations={translations}
          />
        }
        {
          this.state.consequencesShown &&
          <Fragment>
            {
              isFiveByFiveMatrix ?
              <FiveConsequencesTable
                row={this.state.cellRow}
                column={this.state.cellColumn}
                value={this.state.cellValue}
                isNewConsequence={this.state.isNewRisk}
                changeHandler={ (oldValue, newValue, row, column) => this.updateRisk(oldValue, newValue, row, column, null) }
                translations={this.state.translations}
                onUpdate={this.onConsequencesUpdate}
              />
              :
              <SixConsequencesTable
                row={this.state.cellRow}
                column={this.state.cellColumn}
                value={this.state.cellValue}
                isNewConsequence={this.state.isNewRisk}
                changeHandler={ (oldValue, newValue, row, column) => this.updateRisk(oldValue, newValue, row, column, null) }
                onUpdate={this.onConsequencesUpdate}
              />
            }
          </Fragment>
        }
        <span id="plan_table_contextmenu">
          {
            contextMenu.new &&
            <span style={contextMenu.new.style} onClick={ () => this.toggleNewEntryForm(true) }>{contextMenu.new.content}</span>
          }
          {
            ((deleteEntry.column==='work_phase' && deleteEntry.is_custom==='work_phase') ||
            (deleteEntry.column==='activity' && ['work_phase', 'activity'].includes(deleteEntry.is_custom)) || 
            (deleteEntry.column==='hazard' && ['work_phase', 'activity', 'hazard'].includes(deleteEntry.is_custom)) ||
            (deleteEntry.column==='unwanted_event' && ['work_phase', 'activity', 'hazard', 'unwanted_event'].includes(deleteEntry.is_custom))) &&
            <span style={contextMenu.delete.style} onClick={ () => this.setState({showDeleteForm: true}) }>{contextMenu.delete.content}</span>
          }
          {
            contextMenu.out_of_scope &&
            <span style={contextMenu.out_of_scope.style} onClick={ () => this.toggleRisksByLevel(true) }>{contextMenu.out_of_scope.content}</span>
          }
          {
            showNewEntryForm && 
            <NewEntryModal
              headerText={ contextMenu.new.content }
              shown={ showNewEntryForm }
              risk={ newEntry }
              onSubmit={ this.onSubmitEntry }
              onClose={ () => this.toggleNewEntryForm(false) }
              translations={translations}
            />
          }

          { 
            showDeleteForm && 
            <DeleteRiskModal
              shown={ showDeleteForm }
              risk={ deleteEntry }
              onDelete={this.onDelete}
              onClose={ () => this.setState({showDeleteForm: false}) }
              translations={translations}
            />
          }
        </span>
        {
          showInvalidRiskOwnerFormatModal &&
          <NotificationModal
            header="Invalid Format"
            message={ <span>{translations.accountable_people_format}: Firstname Lastname (email) - eg. <b>John Doe (john.doe@teck.com)</b></span> }
            close={this.closeInvalidRiskOwnerFormatModal}
          />
        }
      </span>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    updateSuccess: state.risk.updateSuccess,
    pending: state.risk.pending,
    language: state.language.language,
    languages: state.language.languages,
    getTranslationsSuccess: state.language.getSuccess,
    instanceConfig: state.instance.instanceConfig,
    translations:  state.translations
  }
}

const mapDispatchToProps = (dispatch) => {
  const riskAction = new RiskAction();

  return {
    updateRisk: (plan_id, risk, cellValue, row) => {
      dispatch(updateRisk(plan_id, risk, cellValue, row))
    },
    saveRiskTranslation: (row, translation) => {
      dispatch(saveRiskTranslation(row, translation))
    },
    updateAccountableManager: (risk) => {
      dispatch(riskAction.updateAccountableManager(risk))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanTable);



// WEBPACK FOOTER //
// ./src/views/plan_tables/plan_table.js